
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './utils/auth';

// Pages
import { Landing } from './pages/Landing';
import { Login } from './pages/Login';
import { Signup } from './pages/Signup';
import { Dashboard } from './pages/Dashboard';
import { Editor } from './pages/Editor';
import { Settings } from './pages/Settings';
import { OrgDashboard } from './pages/OrgDashboard';
import { OrgSettings } from './pages/OrgSettings';
import { OrgAdmin } from './pages/OrgAdmin';
import { Admin } from './pages/Admin';

// Protected route wrapper
function ProtectedRoute({ children }: { children: React.ReactNode }) {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                color: 'var(--color-text-secondary)'
            }}>
                Loading...
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    return <>{children}</>;
}

function App() {
    return (
        <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />

            {/* Protected User Routes */}
            <Route
                path="/dashboard"
                element={
                    <ProtectedRoute>
                        <Dashboard />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/editor/:scriptId"
                element={
                    <ProtectedRoute>
                        <Editor />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/settings"
                element={
                    <ProtectedRoute>
                        <Settings />
                    </ProtectedRoute>
                }
            />

            {/* Protected Organization Routes */}
            <Route
                path="/org/:orgId"
                element={
                    <ProtectedRoute>
                        <OrgDashboard />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/org/:orgId/settings"
                element={
                    <ProtectedRoute>
                        <OrgSettings />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/org/:orgId/admin"
                element={
                    <ProtectedRoute>
                        <OrgAdmin />
                    </ProtectedRoute>
                }
            />

            {/* Protected Admin Routes */}
            <Route
                path="/admin"
                element={
                    <ProtectedRoute>
                        <Admin />
                    </ProtectedRoute>
                }
            />

            {/* Catch all - redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}

export default App;
